import React from 'react'
import MainMessage from '../components/MainMessage'
import { PageComponentProps } from 'piral-core'

export default function SignInCallback(props: PageComponentProps) {

    const urlParams = new URLSearchParams(props.location.search)
    const error = urlParams.get('error')
    const errorDescription = urlParams.get('error_description')

    return (
        <>
            <t-page-title>Signing in</t-page-title>
            {error && errorDescription &&
                <MainMessage title='Sign in issue' summary={error}>
                    <div>
                        {errorDescription}
                    </div>
                </MainMessage>
            }
        </>
    )
}
